export { default } from './getDisplayName';
export * from './getDisplayName';